import React from "react";
import { Button } from "@mantine/core";
import {
  FaFileExport,
  FaCircleCheck,
  FaFilter,
  FaMagnifyingGlass,
} from "react-icons/fa6";

const TableActions = ({
  onSearch = () => {},
  onEdit = () => {},
  onChangeStatus = () => {},
}) => {
  return (
    <div className="flex flex-wrap items-center w-full gap-y-2">
      <div className="relative w-60">
        <FaMagnifyingGlass className="absolute justify-center text-gray-400 -translate-y-1/2 pointer-events-none left-4 top-1/2" />
        <input
          type="text"
          placeholder="Search"
          onChange={(e) => onSearch(e.target.value)}
          className="w-full py-2 pl-10 pr-4 text-left border border-gray-300 rounded-full placeholder:text-left focus:outline-none"
        />
      </div>

      <div className="flex items-center ml-auto gap-x-3">
        <Button
          className="bg-gray-100 shadow-md font-MTFont"
          variant="default"
          radius="md"
        >
          <FaFilter size={18} />
        </Button>
        <Button
          className="bg-gray-100 shadow-md font-MTNfont"
          variant="default"
          radius="md"
          onClick={onEdit}
        >
          <span className="flex items-center gap-2 ">
            <FaFileExport size={18} />
            Export
          </span>
        </Button>

        <Button
          radius="md"
          onClick={onChangeStatus}
          className="text-black shadow-md font-MTNfont ps-8 bg-[#FFCC00] hover:bg-[#FFCC00]"
          leftIcon={<FaCircleCheck size={18} />}
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default TableActions;
